module.exports = __webpack_public_path__ + "static/img/3.2f8d068.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/2/7/1/eng/3.png
// module id = Ki+I
// module chunks = 0